<template>
  <ui-card>
    <ui-title class="has-text-white mb-4">
      {{ $t('dashboard_flaws.title') }}
      <div class="float-right">
                  <button class="button is-primary" @click="GoToFlaws()">{{ $t('dashboard_flaws.all_flaws_button') }}</button>
			</div>
    </ui-title>

    <ui-tabs v-model="activeTab" :tabs="tabs" />

    <ui-tab>
      <ui-table
        :key="$i18n.locale"             
        ref="dataTable"
        service="flaw"
        method="getFlaws"
        rowHoverEffect
        :headers="headers"
        :queryParams="getQueryParams"
        :row-tint="getRowTintPerTab"
        :activeTab="activeTab"
        @rowClick="handleRowClick"
      >
        <template v-slot:item.actions="{ item }">
          <span
            class="actions-mail-btn"
            @click.stop="sendMail(item)"
            :class="readonly && 'disabled'"
          >
            <i class="fas fa-envelope"></i>
          </span>
        </template>
      </ui-table>
    </ui-tab>
	</ui-card>
  
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardModalMail from './modal/mail';

export default {
  name: 'DashboardFlawsTable',

  components: { DashboardModalMail },

  props: {
    readonly: { type: Boolean, default: false },
    customerId: { type: String, default: '' }
  },

  data: () => ({
    activeTab: 'toHandle',
    showMailSendModal: false,
    mailItem: null
  }),

  computed: {
    ...mapGetters('user', ['getActiveCustomer', 'getActiveBuilding']),

    headers() {
      return [
        { text: this.$t('dashboard_flaws.header.item'),  value: 'mapItemName',     sortable: true },
        { text: this.$t('dashboard_flaws.header.flaw'),  value: 'name',            sortable: true },
        { text: this.$t('dashboard_flaws.header.found'), value: 'created',         sortable: true,
          transform: val => this.$utils.date.getFullDate(val) },
        { text: this.$t('dashboard_flaws.header.round'), value: 'roundPlanningName', sortable: true },
        { text: '', value: 'actions' }
      ];
    },

    tabs() {
      return [
        { key: 'toHandle', label: this.$t('dashboard_flaws.tab.toHandle'), icon: 'fa-sticky-note' },
        { key: 'late',     label: this.$t('dashboard_flaws.tab.late'),     icon: 'fa-clock' },
        { key: 'done',     label: this.$t('dashboard_flaws.tab.done'),     icon: 'fa-check' },
        { key: 'all',      label: this.$t('dashboard_flaws.tab.all'),      icon: 'fa-align-left' }
      ];
    },

    getQueryParams() {
      const filter = {};

      if (this.activeTab === 'toHandle') {
        filter.done = false;
      }

      if (this.activeTab === 'late') {
        filter.done = false;
        filter.stop = this.moment(new Date()).subtract(30, 'days').toISOString();
      }

      if (this.activeTab === 'done') {
        filter.done = true;
      }

      return {
        customerId: this.customerId,
        buildingId: this.getActiveBuilding.id,
        ...filter
      };
    },

    getRowTintPerTab() {
      switch (this.activeTab) {
        case 'toHandle':
        case 'late':
          return '245 224 224';
        case 'done':
          return '227 245 224';
        default:
          return '245 224 224';
      }
    }
  },

  watch: {
    '$i18n.locale'() {
      this.$nextTick(() => {
        if (this.$refs.dataTable?.fetchData) this.$refs.dataTable.fetchData();
      });
    }
  },

  methods: {
    sendMail(item) {
      this.mailItem = { ...item };
      this.showMailSendModal = true;
    },

    handleRowClick(item) {
      this.$emit('rowClick', item);
    },

		fetchData() {
			this.$refs.dataTable.fetchData();
		},
		GoToFlaws() {
			const buildingId = this.getActiveBuilding.id;
			console.log('clicked', buildingId);

			this.$router.push({
				name: 'RoundHistoryView',
				params: { buildingId: buildingId }
			});
		}


	}
};
</script>

<style lang="scss">
.Dashboard-table-switch {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 20px;
  background-color: lighten(#363a41, 20%);
  border: 1px solid darken(#363a41, 1%);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px inset;

  i {
    color: white;
  }

  span {
    font-size: 12px;
    letter-spacing: 0.05rem;
    margin-right: 5px;
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.actions-mail-btn {
  cursor: pointer;

  &.disabled {
    pointer-events: none;

		> i {
			color: $light-grey;
		}
	}
}
.float-right {
	float: right;
	margin: 2px;
}
</style>
